import { TerrainId } from '@wareena/grid-battles-entity/game/map/terrain';
export const genericTerrainPreferences = [
    TerrainId.Hill,
    TerrainId.Wood,
    TerrainId.Bridge,
    TerrainId.Plain,
];
const terrainPreferencesForAttack = [
    TerrainId.Hill,
    TerrainId.Wood,
    TerrainId.Bridge,
    TerrainId.Plain,
];
const terrainPreferencesForDefense = [
    TerrainId.Wood,
    TerrainId.Bridge,
    TerrainId.Hill,
    TerrainId.Plain,
];
export function getTerrainPreferencesForAttack() {
    return terrainPreferencesForAttack;
}
export function getTerrainPreferencesForDefense() {
    return terrainPreferencesForDefense;
}
